
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(41),
  accountHash: String.withConstraint(x => x.length <= 30),
  clientTimeZone: Number.withConstraint(x => x >= -200 && x <= 200),
  deviceId: Number.withConstraint(x => x >= 0 && x <= 50),
  websiteId: String,
  storeId: Number.withConstraint(x => x >= 0 && x <= 50),
  clientCountryCode: String.withConstraint(x => x.length <= 10),
  browserLang: String.withConstraint(x => x.length <= 15),
  event_mapping_version: Literal(2),
}).And(Partial({
  partnerId: Number,
  creative: Number,
  placement: String.withConstraint(x => x.length <= 100),
  keyword: String.withConstraint(x => x.length <= 150),
  googleNetwork: String.withConstraint(x => x.length <= 1),
  lp: Number,
  cid: String.withConstraint(x => x.length <= 25),
  tid: String.withConstraint(x => x.length <= 25),
  aid: Number,
  camp: Number,
  adgr: Number,
  matchtype: String.withConstraint(x => x.length <= 1),
  referrer: String.withConstraint(x => x.length <= 100),
  geoIpRequestTime: Number,
  countryDetectionFactor: Number,
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(41),
  accountHash: String.withConstraint(x => x.length <= 30),
  clientTimeZone: Number.withConstraint(x => x >= -200 && x <= 200),
  deviceId: Number.withConstraint(x => x >= 0 && x <= 50),
  websiteId: String,
  storeId: Number.withConstraint(x => x >= 0 && x <= 50),
  clientCountryCode: String.withConstraint(x => x.length <= 10),
  browserLang: String.withConstraint(x => x.length <= 15),
  event_mapping_version: Literal(2),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  lang: String.withConstraint(x => x.length <= 5),
}).And(Partial({
  partnerId: Number,
  creative: Number,
  placement: String.withConstraint(x => x.length <= 100),
  keyword: String.withConstraint(x => x.length <= 150),
  googleNetwork: String.withConstraint(x => x.length <= 1),
  lp: Number,
  cid: String.withConstraint(x => x.length <= 25),
  tid: String.withConstraint(x => x.length <= 25),
  aid: Number,
  camp: Number,
  adgr: Number,
  matchtype: String.withConstraint(x => x.length <= 1),
  referrer: String.withConstraint(x => x.length <= 100),
  geoIpRequestTime: Number,
  countryDetectionFactor: Number,
  zoneId: Number.withConstraint(x => x >= 0 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 41;
  